export default __webpack_public_path__ + "static/media/m1.52331a52.webp";